"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_bootstrap_1 = require("react-bootstrap");
const react_redux_1 = require("react-redux");
const LandingActions_1 = require("../../LandingActions");
const LandingStore_1 = require("../../LandingStore");
const emailPanel_1 = require("../../emailPanel/emailPanel");
const mapDispatchToProps = dispatch => {
    return {
        openModal: modal => dispatch(LandingActions_1.openModal(modal))
    };
};
class HeaderPartComponent extends React.Component {
    componentDidMount() {
        document.body.scrollTop = 0;
        $('#homeItem').addClass('active-item');
        if ($('#contactItem').hasClass('active-item')) {
            $('#homeItem').removeClass('active-item');
        }
        if ($('#homeItem').hasClass('active-item')) {
            $('#contactItem').removeClass('active-item');
        }
        $('#homeItem').click(function () {
            $('#contactItem').removeClass('active-item');
            $('#homeItem').addClass('active-item');
            document.body.scrollTop = 0;
        });
    }
    componentWillUnmount() {
        $('#homeItem').removeClass('active-item');
    }
    render() {
        return React.createElement(react_bootstrap_1.Row, { className: "header-component" }, React.createElement(react_bootstrap_1.Col, { xs: 12, md: 12, sm: 12, className: "header-component-text text-left" }, React.createElement("div", { className: "hero-header" }, React.createElement("h1", null, "Real Feedback!"), React.createElement("h2", { className: "thinText" }, "Instant customer feedback to multiple", React.createElement("br", null), " mobile phones simultaneously"))), React.createElement(react_bootstrap_1.Col, { xs: 6, md: 6, sm: 6 }, React.createElement(react_bootstrap_1.Image, { className: "video-player pointer", src: "../img/video_player.png", onClick: () => {
                this.props.openModal(LandingStore_1.LandingModal.Video);document.body.scrollTop = 0;
            } })), React.createElement(react_bootstrap_1.Col, { xs: 12, md: 12, sm: 12 }, React.createElement(emailPanel_1.default, null)));
    }
}
const HeaderPart = react_redux_1.connect(null, mapDispatchToProps)(HeaderPartComponent);
exports.default = HeaderPart;


//////////////////
// WEBPACK FOOTER
// ./client/src/landing/home/components/HeaderPart.tsx
// module id = 1106
// module chunks = 0 1